const paymentData = {
  monthly: {
    paymentType: 'monthly',
    membershipSku: 'IFMMN',
    kitOrItemId: '59e62cb16fc2360044e2f98f'
  },
  yearly: {
    paymentType: 'yearly',
    membershipSku: 'IFMYN',
    kitOrItemId: '59e6364694c348003eb60cc8'
  }
};

export function getPaymentData(paymentType) {
  return paymentData[paymentType];
}
